"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _mapPositionUtils = require("./mapPositionUtils");

var _constants = require("./constants");

var _BoundaryManager = require("../BoundaryManager/BoundaryManager");

var _jsxFileName = "/builds/zillow/searchxp/zillow-map-control/src/util/MapContentPositioner.jsx";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var MapContentPositioner =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(MapContentPositioner, _Component);

  MapContentPositioner.elementToMapEdge = function elementToMapEdge(mapRange, markerDimensions, childTranslatePosition) {
    // Calculates the pixel difference between the map marker and each of the edges
    // returns {top, bottom, left, right} which reference marker pixel distance to edge
    // Markers are present on the map when their center point is on the map.
    // If your coordinates are already centered, please set x and y to 0.
    var mapMarkerCenter = {
      x: childTranslatePosition.x < 0 ? childTranslatePosition.x + markerDimensions.x : childTranslatePosition.x - markerDimensions.x,
      y: childTranslatePosition.y < 0 ? childTranslatePosition.y + markerDimensions.y : childTranslatePosition.y - markerDimensions.y
    };
    var distanceTo = {};
    var mapWidth = mapRange.x * 2;
    var mapHeight = mapRange.y * 2;

    if (mapMarkerCenter.x < 0) {
      distanceTo.left = mapRange.x + mapMarkerCenter.x;
      distanceTo.right = mapWidth - distanceTo.left;
    } else {
      distanceTo.right = mapRange.x - mapMarkerCenter.x;
      distanceTo.left = mapWidth - distanceTo.right;
    }

    if (mapMarkerCenter.y < 0) {
      distanceTo.top = mapRange.y + mapMarkerCenter.y;
      distanceTo.bottom = mapHeight - distanceTo.top;
    } else {
      distanceTo.bottom = mapRange.y - mapMarkerCenter.y;
      distanceTo.top = mapHeight - distanceTo.bottom;
    }

    distanceTo.top = mapHeight - distanceTo.bottom;
    return distanceTo;
  };

  function MapContentPositioner(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.mapChildDot = _this.mapChildDot.bind(_assertThisInitialized(_this));
    _this.cachedTranslations = {};
    return _this;
  }

  var _proto = MapContentPositioner.prototype;

  _proto.getDots = function getDots() {
    if (!this.props.overlay || (0, _isEmpty2.default)(this.props.children)) {
      return null;
    } // Because translations are the same for each tile or lat/lng pair in a given render pass,
    // we can cache the translation calculations for each of those unique objects


    this.cachedTranslations = {};
    return _react.default.Children.map(this.props.children, this.mapChildDot);
  };

  _proto.calculateRowColZoomTranslate = function calculateRowColZoomTranslate(child) {
    var _child$props = child.props,
        row = _child$props.row,
        column = _child$props.column,
        zoom = _child$props.zoom;
    var overlay = this.props.overlay;
    var topLeftLatLngObj = (0, _mapPositionUtils.tileToLatLng)(row, column, zoom + 1);
    var topLeftLatLng = new google.maps.LatLng(topLeftLatLngObj.latDeg, topLeftLatLngObj.lngDeg);
    var projection = overlay.getProjection();

    if (projection) {
      var topLeft = projection.fromLatLngToDivPixel(topLeftLatLng);
      var childLeft = topLeft.x;
      var childTop = topLeft.y;
      return {
        transform: "translateX(-50%) translateX(" + childLeft + "px) translateY(-50%) translateY(" + childTop + "px)"
      };
    } // console log will be removed by babel.
    // eslint-disable-next-line no-console


    console.log("Google map projection missing");
    return {
      // If the projection is missing, just render to 0,0.
      transform: 'translateX(-50%) translateX(0px) translateY(-50%) translateY(0px)'
    };
  };

  _proto.calculateLngLatTranslate = function calculateLngLatTranslate(child) {
    var _child$props2 = child.props,
        northSouthLat = _child$props2.northSouthLat,
        eastWestLng = _child$props2.eastWestLng,
        markerDimensions = _child$props2.markerDimensions;
    var overlay = this.props.overlay; // valid example
    // lat = 45.479898
    // lng = -122.5904647

    var lat = northSouthLat;
    var lng = eastWestLng;

    if (Math.abs(lat) > 1000) {
      lat /= 1000000;
      lng /= 1000000;
    }

    var latLng = new google.maps.LatLng(lat, lng);
    var topRight = overlay.getProjection().fromLatLngToDivPixel(latLng);

    if (markerDimensions) {
      // We take NE and SW to avoid rounding issues
      var NorthEastRange = overlay.getProjection().fromLatLngToDivPixel(overlay.getMap().getBounds().getNorthEast());
      var SouthWestRange = overlay.getProjection().fromLatLngToDivPixel(overlay.getMap().getBounds().getSouthWest());
      var XRange = (NorthEastRange.x + Math.abs(SouthWestRange.x)) / 2;
      var YRange = (Math.abs(NorthEastRange.y) + SouthWestRange.y) / 2;
      var mapXYRange = {
        x: XRange,
        y: YRange
      };
      var elementMapPosition; // if the mapXYRange is less than 1 pixel, the map isn't visible

      if (Math.abs(mapXYRange.x) < 1 || Math.abs(mapXYRange.y) < 1) {
        elementMapPosition = {
          bottom: 0,
          top: 0,
          right: 0,
          left: 0
        };
      } else {
        mapXYRange.y = Math.abs(mapXYRange.y);
        elementMapPosition = MapContentPositioner.elementToMapEdge(mapXYRange, markerDimensions, topRight);
      }

      elementMapPosition.x = topRight.x;
      elementMapPosition.y = topRight.y;
      return elementMapPosition;
    }

    var childLeft = topRight.x;
    var childTop = topRight.y;
    return {
      transform: "translateX(-50%) translateX(" + childLeft + "px) translateY(-50%) translateY(" + childTop + "px)"
    };
  };

  _proto.mapChildDot = function mapChildDot(child) {
    if (!child || !child.props) {
      return null;
    }

    var _child$props3 = child.props,
        northSouthLat = _child$props3.northSouthLat,
        eastWestLng = _child$props3.eastWestLng,
        row = _child$props3.row,
        column = _child$props3.column,
        selected = _child$props3.selected,
        isHovered = _child$props3.isHovered,
        markerDimensions = _child$props3.markerDimensions,
        allowGoogleMapEvents = _child$props3.allowGoogleMapEvents;
    var key = northSouthLat && eastWestLng ? northSouthLat + "_" + eastWestLng : row + "_" + column;
    var dotPositionStyle = null;

    if (markerDimensions) {
      // Do not cache or use cache for markers with markerDimensions
      // as they dynamically move, and may key collide with other non 
      // marker dimension items.
      dotPositionStyle = northSouthLat && eastWestLng ? this.calculateLngLatTranslate(child) : this.calculateRowColZoomTranslate(child);
    } else {
      if ((0, _isEmpty2.default)(this.cachedTranslations[key])) {
        this.cachedTranslations[key] = northSouthLat && eastWestLng ? this.calculateLngLatTranslate(child) : this.calculateRowColZoomTranslate(child);
      }

      dotPositionStyle = this.cachedTranslations[key];
    } // SXP-2634 this selected prop doesn't appear to be passed in from anywhere
    // It should be used to change this zIndex and mapmarker color to green


    if (selected || isHovered) {
      dotPositionStyle.zIndex = 1;
    }

    if (markerDimensions) {
      return _react.default.createElement("div", {
        className: "marker-position marker-pop-up",
        key: "parceldiv_" + child.key,
        role: "presentation",
        onClick: _BoundaryManager.ignoreGoogleMapEvents,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 212
        },
        __self: this
      }, _react.default.createElement("div", {
        className: "marker-flex",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 213
        },
        __self: this
      }, _react.default.cloneElement(child, {
        elementMapPosition: dotPositionStyle
      })));
    }

    return _react.default.createElement("div", {
      className: "marker-position",
      style: dotPositionStyle,
      key: "parceldiv_" + child.key,
      role: "presentation",
      onClick: allowGoogleMapEvents ? null : _BoundaryManager.ignoreGoogleMapEvents,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 226
      },
      __self: this
    }, _react.default.createElement("div", {
      className: "marker-flex",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 227
      },
      __self: this
    }, child));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        zoom = _this$props.zoom,
        children = _this$props.children;
    var zoomClass = zoom > _constants.DEFAULT_HIGH_ZOOM_LEVEL ? 'high-zoom' : 'low-zoom';
    var countClass = _react.default.Children.count(children) > 100 ? 'many-results' : 'few-results';
    /* eslint-disable zillow/jsx-a11y/no-static-element-interactions */

    /* eslint-disable zillow/jsx-a11y/click-events-have-key-events */

    return _react.default.createElement("div", {
      className: "BulkPropertyMapMarker " + zoomClass + " " + countClass,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 245
      },
      __self: this
    }, this.getDots());
    /* eslint-enable zillow/jsx-a11y/no-static-element-interactions */

    /* eslint-enable zillow/jsx-a11y/click-events-have-key-events */
  };

  return MapContentPositioner;
}(_react.Component);

MapContentPositioner.propTypes = process.env.NODE_ENV !== "production" ? {
  zoom: _propTypes.default.number,
  // The google map object for projection mapping lat lng to pixel positions
  overlay: _propTypes.default.shape({}).isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
} : {};
MapContentPositioner.defaultProps = {
  zoom: 0,
  children: []
};
var _default = MapContentPositioner;
exports.default = _default;